import { WSDispatcher } from 'socket';
import uuidv4 from 'uuid/v4';
import { publish } from 'pub-sub';
import timesync from 'timesync';
import { logout_expired } from 'logout';
import { logSystem } from '@holmescorp/logger';
import * as moment from 'moment';
const checkExpired = (closing) => {
    if (window.hcstatic.portal_auth_expires) {
        const expires = moment(window.hcstatic.portal_auth_expires, 'YYYY-MM-DD HH:mm:ss Z');
        const limit = moment().add(15, 'minutes');
        if (limit.isAfter(expires)) {
            logout_expired(closing);
        }
    }
};
export function wsActivate(onlineChange) {
    if (!window.hcstatic.sessionid) {
        window.hcstatic.sessionid = uuidv4();
    }
    const { portal_host, portal_site } = window.hcstatic;
    const scheme = /hclspdev|staging|partnerrc|jeff-mbp/.test(window.location.hostname) ? 'wss://' : 'ws://';
    const ws = new WSDispatcher({
        url: `${scheme}${portal_host}/${portal_site}/@@ws`
    });
    ws.on('open', () => {
        logSystem.info('WebSocket open');
        checkExpired(false);
        timesync.startup();
        publish('app:socket:connected', {});
        onlineChange &&
            onlineChange({
                online: true
            });
    });
    ws.on('close', () => {
        logSystem.info('WebSocket closed');
        timesync.cancel();
        checkExpired(true);
        publish('app:socket:disconnected', {});
        onlineChange &&
            onlineChange({
                online: false
            });
    });
    ws.on('error', () => {
        logSystem.info('WebSocket error');
    });
    ws.open();
    return ws;
}
export default wsActivate;
